module.exports = __webpack_public_path__ + "media/images/pc/reports/mv_title_ribbon_side-31ca65d8e56b388d5569f014f96b29b3.png";